/* ============================================================
   SEC F: Stories pill filter — client-side tag-based filtering
   + dynamic "more articles" link (D-6)
   ============================================================ */

(function () {
  'use strict';

  var section = document.querySelector('.section-stories');
  if (!section) return;

  var pills = section.querySelectorAll('.stories__pill');
  var cards = section.querySelectorAll('.stories__article-card');
  var gridTrack = section.querySelector('.stories__grid-track');
  var moreLink = section.querySelector('[data-more-link]');
  var moreLabel = moreLink ? moreLink.querySelector('.stories__more-label') : null;
  var blogHandle = section.getAttribute('data-blog-handle') || 'news';

  if (!pills.length) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var tag = this.getAttribute('data-tag');

      /* Update active pill */
      pills.forEach(function (p) {
        p.classList.remove('stories__pill--active');
        p.setAttribute('aria-selected', 'false');
      });
      this.classList.add('stories__pill--active');
      this.setAttribute('aria-selected', 'true');

      /* Filter cards */
      cards.forEach(function (card) {
        if (tag === 'all') {
          card.hidden = false;
          return;
        }
        var cardTags = (card.getAttribute('data-tags') || '').split(',');
        card.hidden = cardTags.indexOf(tag) === -1;
      });

      /* scroll-snap mandatory が DOM 変化で近い snap point に再 snap して
         1 枚目が左端からずれる挙動を防ぐ。pill クリックごとに左端リセット */
      if (gridTrack) {
        gridTrack.scrollLeft = 0;
      }

      /* "もっと見る" link (D-6) — Japanese tag は encodeURIComponent でURL化 */
      if (moreLink) {
        if (tag === 'all') {
          moreLink.hidden = true;
        } else {
          moreLink.href = '/blogs/' + blogHandle + '/tagged/' + encodeURIComponent(tag);
          if (moreLabel) {
            moreLabel.textContent = '→ #' + tag + ' の記事をもっと見る';
          }
          moreLink.hidden = false;
        }
      }
    });
  });
})();
